import { render, staticRenderFns } from "./products-grouped-by-group.vue?vue&type=template&id=37176ceb&scoped=true&"
import script from "./products-grouped-by-group.vue?vue&type=script&lang=ts&"
export * from "./products-grouped-by-group.vue?vue&type=script&lang=ts&"
import style0 from "./products-grouped-by-group.vue?vue&type=style&index=0&id=37176ceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37176ceb",
  null
  
)

export default component.exports